import { render, staticRenderFns } from "./UpdatePerson.vue?vue&type=template&id=15b2a178"
import script from "./UpdatePerson.vue?vue&type=script&lang=js"
export * from "./UpdatePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports